import { render } from "./MainLayout.vue?vue&type=template&id=74ee1070&scoped=true"
import script from "./MainLayout.vue?vue&type=script&lang=js"
export * from "./MainLayout.vue?vue&type=script&lang=js"

import "./MainLayout.vue?vue&type=style&index=0&id=74ee1070&lang=scss"
import "./MainLayout.vue?vue&type=style&index=1&id=74ee1070&scoped=true&lang=css"

import exportComponent from "/var/www/zaytoon-frontend-base/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74ee1070"]])

export default __exports__